import { ClusteringMethod, useCurrentCompany } from '@neo.tax/shared';

// Returns true when the company's ASC sync configuration is using capitalizable project clustering
// (CPC). All CPC-only UI elements (matching target column, drawer dropdown, batch actions,
// bulk upload, pre-sync review) should be gated behind this.
export const useIsCapitalizedProjectClustering = (): boolean => {
  const { company } = useCurrentCompany();
  return company?.syncConfigurationAsc?.clusteringMethod === ClusteringMethod.CapitalizableProject;
};
